import { render, staticRenderFns } from "./HealthPemantauan.vue?vue&type=template&id=6d6c85d6&"
import script from "./HealthPemantauan.vue?vue&type=script&lang=js&"
export * from "./HealthPemantauan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports